import { ObjHlp } from 'src/lib/fliko/helpers/object.helper';
import { Collection } from 'src/lib/fliko/types/database.type';
import { Nullish } from 'src/lib/fliko/types/typeish.type';

export class TranslationHelper {
  public static getTitle(data: { id: string; title: string }, titles: Collection<string> | Nullish) {
    return ObjHlp.get(titles, data.id) ?? data.title;
  }
}
